<template>
  <div>
    <div class="container mx-auto my-8 p- bg-white rounded-lg">
      <!-- Loader -->
      <div v-if="isLoading" class="flex justify-center items-center py-20">
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
      ></div>
    </div>  

      <!-- For Manager, show talents in a single table -->
      <div v-else-if="isManager" class="space-y-6">
        <div v-if="talents.length === 0" class="text-center text-bodyText">
          <p class=" mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]">
            Manager has no projects and talents available.
          </p>
        </div>


        <div v-else class="overflow-x-auto">
          <div class="hidden md:block">
            <table class="min-w-full divide-y">
              <thead class="text-[12px] text-bodyText">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">Name</th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">Position</th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">Projects</th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">Date Joined</th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200 text-[13px]">
                <!-- <tr v-for="talent in talents" :key="talent.talent_id" @click="openSideMenu(talent)" -->
                <tr v-for="talent in talents" :key="talent.talent_id" @click="goToTalent(talent.talent_id)"
                  class="border-t hover:bg-gray-50 transition text-bodyText">
                  <td class="px-6 py-4 text-[13px] whitespace-nowrap flex items-center gap-2 p-4">
                    <p class="font-medium">{{ talent.talent_first_name }} {{ talent.talent_last_name }}</p>
                    <div class="w-1 h-1 bg-grayDark rounded-full"></div>
                    <p class="">{{ talent.talent_email }}</p>
                  </td>
                  <td class="py-4 whitespace-nowrap">{{ talent.talent_role }}</td>

                  <td class="py-4 whitespace-nowrap font-medium">
                    <div class="ml-4">
                      <div class="flex items-center gap-2">
                        <router-link v-for="project in talent.projects" :key="project.project_id"
                          :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }"
                          class="bg-[#F0F1F3] text-grayDark border border-primaryLight flex items-center justify-center w-[24px] h-[24px] rounded-[4px] font-bold -ml-3 hover:bg-primaryLight hover:text-primaryDark transition">
                          {{ project.project_name.charAt(0).toUpperCase() }}
                        </router-link>
                        {{ }}
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">{{ talent.date_joined }}</td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <button @click="goToReports(talent.projects[0]?.project_id, talent.talent_id)"
                      class="transition flex items-center gap-4">
                      View Reports
                      <img src="@/assets/reports/arrow-right.svg" alt="Chevron icon" class="h-4" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mobile Card View -->
          <div class="md:hidden">
            <div v-for="(talent) in talents" :key="talent.talent_id" @click="openSideMenu(talent)"
              class="bg-white rounded-lg mb-4 p-4 border border-gray-100 text-bodyText">
              <div class="grid grid-cols-3 gap-8 ">
                <!-- Project Name -->
                <div class="space-y-1">
                  <p class="text-[12px]">Name</p>
                  <p class="font-medium">{{ talent.talent_first_name }} {{ talent.talent_last_name }}</p>
                </div>
                <div class="space-y-1">
                  <p class="text-[12px]">Role</p>
                  <p class="py-4 whitespace-nowrap">{{ talent.talent_role }}</p>
                </div>


                <!-- Action button -->
                <div class="items-center">
                  <button @click="goToReports(talent.projects[0]?.project_id, talent.talent_id)"
                      class="transition flex items-center gap-4">
                      View Reports
                      <img src="@/assets/reports/arrow-right.svg" alt="Chevron icon" class="h-4" />
                    </button>
                </div>

                <div class="space-y-1">
                  <div class="text-xs text-gray-500">Date Joined</div>
                  <div class="text-[13px]">{{ talent.date_joined }}</div>
                </div>

                <div class="ml-4">
                      <div class="flex items-center gap-2">
                        <router-link v-for="project in talent.projects" :key="project.project_id"
                          :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }"
                          class="bg-[#F0F1F3] text-grayDark border border-primaryLight flex items-center justify-center w-[24px] h-[24px] rounded-[4px] font-bold -ml-3 hover:bg-primaryLight hover:text-primaryDark transition">
                          {{ project.project_name.charAt(0).toUpperCase() }}
                        </router-link>
                        {{ }}
                      </div>
                    </div>

                
              </div>
            </div>
          </div>

        </div>


      </div>
      <div v-else-if="isAdmin" class="space-y-6">
        <div v-if="talents.length === 0" class="text-center text-bodyText">
          <p class=" mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]">
            No talents available.
          </p>
        </div>


        <div v-else class="overflow-x-auto">
          <table class="min-w-full divide-y">
            <thead class="text-[12px] text-bodyText">
              <tr>
                <th scope="col" class="px-6 py-3 text-left tracking-wider">Name</th>
                <th scope="col" class="px-6 py-3 text-left tracking-wider">Position</th>
                <th scope="col" class="px-6 py-3 text-left tracking-wider">Projects</th>
                <th scope="col" class="px-6 py-3 text-left tracking-wider">Date Joined</th>
                <th scope="col" class="px-6 py-3 text-left tracking-wider">Actions</th>
                <!-- <th scope="col" class="px-6 py-3 text-left tracking-wider"></th> -->
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200 text-[13px]">
              <tr v-for="talent in talents" :key="talent.talent_id" @click="openSideMenu(talent)"
                class="border-t hover:bg-gray-50 transition text-bodyText">
                <td class="flex gap-3 px-6 py-4 whitespace-nowrap">
                  <div
                    class="w-[42px] h-[42px] flex items-center justify-center rounded-full text-white font-semibold bg-[#A3DB7D]">
                    {{ getInitials(talent.user.first_name, talent.user.last_name) }}
                  </div>

                  <div>
                    <p class="font-medium text-gray-900">
                      {{ capitalize(talent.user.first_name) }} {{ capitalize(talent.user.last_name) }}
                    </p>
                    <p class="text-grayDark">{{ talent.user.email }}</p>
                  </div>
                </td>
                <td class="py-4 whitespace-nowrap">{{ talent.position }}</td>
                <td class="py-4 whitespace-nowrap font-medium">
                  <div class="ml-4">
                    <div class="flex items-center gap-2">
                      <router-link v-for="project in talent.projects" :key="project.projectId"
                        :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }"
                        class="bg-[#F0F1F3] text-grayDark border border-primaryLight flex items-center justify-center w-[24px] h-[24px] rounded-[4px] font-bold -ml-3 text-[12px] hover:bg-primaryLight hover:text-primaryDark transition">
                        {{ project.project_name.charAt(0).toUpperCase() }}

                      </router-link>
                    </div>
                  </div>

                </td>
                <!-- <td class="px-6 flex py-4 whitespace-nowrap">
                    <p v-for="(project) in talent.projects.slice(0, 3)" :key="project.project_id">
                    <router-link 
                        :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }" 
                        class="text-blue-500 mr-2"
                    >
                        {{ project.project_name }},
                    </router-link>
                    </p>
                    <p v-if="talent.projects.length > 3" class="text-grayDark italic">...
                    </p>
                  </td> -->
                <td class="px-6 py-4 whitespace-nowrap ">{{ talent.date_joined }}</td>
                <td class="px-6 py-4 whitespace-nowrap ">
                  <button @click="goToReports(talent.projects[0]?.projectId, talent.talent_user_id)"
                    class="transition flex items-center  gap-4">
                    View Reports
                    <img src="@/assets/reports/arrow-right.svg" alt="Chevron icon" class="h-4" />
                  </button>
                </td>
                <!-- <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <img src="@/assets/projects/options.svg" alt="Options" @click.stop="toggleDropdown(talent.talent_id)" class="h-6 cursor-pointer" />
                  <div v-if="isDropdownOpen(talent.talent_id)" class="absolute right-0 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                       <button @click="editUser(manager.manager_id)" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Edit User</button> 
                      <button @click="openRoleModal(talent)" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Edit Role</button>
                       <button @click="openRoleModal(talent)" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Remove manager</button> 
                  </div>
                  </td> -->
              </tr>
            </tbody>
          </table>
        </div>


      </div>

      <!-- Edit Talent Modal -->
      <EditTalentModal :isVisible="showEditModal" :selectedTalent="selectedTalent" @save="submitEditModal"
        @close="closeEditModal" />
    </div>
  </div>


  <!-- Glass Overlay -->
  <div v-if="isSideMenuOpen" class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40" @click="closeSideMenu">
  </div>

  <div v-if="isSideMenuOpen"
    class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px]">
    <!-- <div > -->
    <div class="space-y-4">
      <div class="py-4 px-4 flex justify-between items-center border-b-[1px] border-grayLight">
        <h3 class="text-lg font-medium">Talent Profile</h3>

        <div class="flex space-x-2 items-center">
          <img src="@/assets/tasks/paperclip.svg" alt="Options" class="h-6 cursor-pointer" />
          <img src="@/assets/projects/options.svg" alt="Options" class="h-6 cursor-pointer" />
          <div @click="closeSideMenu" class="bg-[#FAFBFC] h-8 rounded-full flex items-center justify-center">
            <img src="@/assets/tasks/iconoir_cancel.svg" alt="Options" class="h-6 cursor-pointer" />
          </div>
        </div>
      </div>
      <!-- <hr class="w-full border-t border-grayLight rounded-full"> -->


    </div>
    <div class="px-5 py-4 space-y-4 text-grayDark text-[13px]">
      <div class="space-y-3">
        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>First name</p>
          </div>
          <span>{{ selectedMember?.user?.first_name || selectedMember?.talent_first_name }}</span>
        </div>
        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Last name</p>
          </div>
          <span class="">{{ selectedMember?.user.last_name || selectedMember?.talent.last_name }}</span>
        </div>
        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Email</p>
          </div>
          <span class="">{{ selectedMember?.talent_email || selectedMember?.user.email }}</span>
        </div>

        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Phone</p>
          </div>
          <span class="">{{ selectedMember?.talent_phone }}</span>
        </div>

        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Portfolio url</p>
          </div>
          <span class="">{{ selectedMember?.portfolio_url || "Add portfolio" }}</span>
        </div>

        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] items-center">
            <p>Skills</p>
          </div>
          <div class="flex gap-2">
            <p v-for="skill in selectedMember?.skills" :key="skill.skill_id">
              {{ skill.skill_name }}
            </p>
          </div>

        </div>

        <div class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Goals</p>
          </div>
          <div class="flex items-center gap-2">
            <router-link v-for="project in selectedMember?.projects" :key="project.projectId"
              :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }"
              class="text-grayDark underline hover:text-primaryDark">
              {{ project.project_name }}
            </router-link>
          </div>
        </div>

        <!-- <div class="flex items-center gap-2">
                        <router-link
                          v-for="project in talent.projects"
                          :key="project.projectId"
                          :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }"
                          class="bg-[#F0F1F3] text-grayDark border border-primaryLight flex items-center justify-center w-[24px] h-[24px] rounded-[4px] font-bold -ml-3 hover:bg-primaryLight hover:text-primaryDark transition"
                        >
                          {{ project.project_name.charAt(0).toUpperCase() }}
                        </router-link>
                        {{  }}
                      </div> -->

      </div>
    </div>
  </div>


</template>



<script>
import { reactive } from 'vue';
import apiClient from '@/axios';
import EditTalentModal from '@/components/modals/EditTalentModal.vue';

export default {
  name: 'TalentManagementComponent',
  components: {
    EditTalentModal,
  },
  data() {
    return {
      isSideMenuOpen: false,
      talents: [], // For admin
      managedProjects: [],
      isLoading: true,
      showEditModal: false,
      selectedTalent: {
        first_name: '',
        last_name: '',
        email: ''
      },
      availableSkills: [],
      selectedSkill: '',
      dropdowns: reactive({}), // Track dropdown states

    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    filteredProjects() {
      console.log("Talent Projects:", this.talent?.projects);

      return this.talent?.projects?.filter(p => p.project_name) || [];
    }
  },

  methods: {
    goToTalent(talentId) {
      this.$router.push({ name: 'TalentDetails', params: { talentId } });
    },
    openRoleModal(talent) {
      this.selectedTalent = talent;
      this.newRole = talent.role || ''; // Set the existing role, if applicable
      this.talentPortfolio_url = talent.portfolio_url || ''; // Set the existing industry, if applicable
      this.talentPosition = talent.position || '';
      this.showModal = true;
    },
    closeRoleModal() {
      this.showModal = false;
      this.newRole = '';
      this.managerIndustry = '';
      this.portfolioUrl = '';
      this.position = '';
    },
    toggleDropdown(talentId) {
      Object.keys(this.dropdowns).forEach(key => {
        this.dropdowns[key] = false;
      });
      this.dropdowns[talentId] = !this.dropdowns[talentId];
    },
    closeDropdown() {
      Object.keys(this.dropdowns).forEach(key => {
        this.dropdowns[key] = false;
      });
    },
    isDropdownOpen(talentId) {
      return !!this.dropdowns[talentId];
    },
    getInitials(firstName, lastName) {
      const firstInitial = firstName ? firstName.trim().charAt(0).toUpperCase() : '';
      const lastInitial = lastName ? lastName.trim().charAt(0).toUpperCase() : '';
      return `${firstInitial}${lastInitial}`;
    },
    capitalize(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    openSideMenu(member) {
      this.selectedMember = { ...member };
      this.isSideMenuOpen = true;
    },
    closeSideMenu() {
      this.isSideMenuOpen = false;
      this.selectedMember = null;
      this.showSuccess = "";
      this.successMessage = "";
      this.errorMessage = "";
    },
    // Helper method to check if a project has valid members
    hasValidMembers(members) {
      return members && members.some(member => member.talent_user_id !== null);
    },

    async fetchTalents() {
      try {
        this.isLoading = true;

        if (this.isManager) {
          const response = await apiClient.get('/web/manager/me');
          const managerData = response.data.data;
          const projects = managerData.projects || [];

          // Map talents from project members
          const talentsMap = {};
          projects.forEach((project) => {
            project.project_members?.forEach((member) => {
              if (!member.talent_id) return; // Skip invalid members

              if (!talentsMap[member.talent_id]) {
                talentsMap[member.talent_id] = {
                  talent_id: member.talent_id,
                  talent_first_name: member.member_first_name || "N/A",
                  talent_last_name: member.member_last_name || "N/A",
                  talent_email: member.member_email || "No Email",
                  talent_phone: member.member_phone || "No phone",
                  talent_role: member.position || "No Role",
                  date_joined: member.date_joined || null,
                  projects: [],
                  skills: [],
                };
              }

              // Add project to the talent's project list
              talentsMap[member.talent_id].projects.push({
                project_id: project.project_id,
                project_name: project.project_name,
              });

              if (member.member_skills) {
                member.member_skills.forEach((skill) => {
                  // Ensure no duplicate skills are added
                  if (!talentsMap[member.talent_id].skills.some((s) => s.skill_id === skill.skill_id)) {
                    talentsMap[member.talent_id].skills.push({
                      skill_id: skill.skill_id,
                      skill_name: skill.skill_name,
                    });
                  }
                });
              }
            });
          });

          // Convert talentsMap to an array
          this.talents = Object.values(talentsMap);
        }

        if (this.isAdmin) {
          const response = await apiClient.get('/web/talents');
          this.talents = response.data.data.filter(talent => talent.user);
        }

      } catch (error) {
        console.error("Error fetching talents or projects:", error);
      } finally {
        this.isLoading = false;
      }
    },

    processData(rawData) {
      const talentsMap = {};

      rawData.forEach(row => {
        // Skip rows without a valid talent_user_id
        if (!row.talent_user_id) return;

        // If the talent doesn't exist in the map, create an entry
        if (!talentsMap[row.talent_user_id]) {
          talentsMap[row.talent_user_id] = {
            talent_user_id: row.talent_user_id,
            talent_first_name: row.talent_first_name,
            talent_last_name: row.talent_last_name,
            talent_email: row.talent_email,
            talent_role: row.talent_role,
            projects: []
          };
        }

        // Add the project to the talent's projects array
        talentsMap[row.talent_user_id].projects.push({
          projectId: row.projectId,
          projectName: row.projectName
        });
      });

      // Convert the map to an array
      this.talents = Object.values(talentsMap);
    },

    goToReports(projectId, userId) {
      if (!projectId || !userId) {
        console.error("Missing required parameters for navigation.");
        return;
      }

      // Navigate to the report page for the specific project and user
      this.$router.push({ name: 'ProgressReports', params: { projectId, userId } });
    },

    openEditModal(talent) {
      this.selectedTalent = { ...talent }; // Clone the talent data
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    async submitEditModal(updatedTalent) {
      try {
        await apiClient.put(`/web/talents/${updatedTalent.user_id}`, {
          user: updatedTalent,
          skill_id: this.selectedSkill
        });
        this.fetchTalents(); // Refresh the talents list
      } catch (error) {
        console.error('Error updating talent:', error);
      } finally {
        this.closeEditModal();
      }
    }
  },
  created() {
    this.fetchTalents();
  }
};
</script>

<style scoped>
.container {
  max-width: 1120px;
  margin: auto;
}

h1,
h2 {
  color: #333;
}

table {
  border-collapse: collapse;
}

th,
td {
  padding: 1rem;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

button {
  font-weight: 500;
}
</style>